import * as api from '../../api'
import * as actions from '../actions/mealDetail'

export const getMealDetail = meal_id => dispatch => {
  dispatch(actions.getMealDetail())
  return api
    .getMealDetail({ meal_id })
    .then(res =>
      dispatch(
        actions.getMealDetailSuccess({
          ...res.data.meal
        })
      )
    )
    .catch(err => dispatch(actions.getMealDetailFail(err)))
}



// WEBPACK FOOTER //
// ./src/store/effects/mealDetail.js